export const PeriodTabs = {
    timeline: 'Timeline',
    list: 'List',
} as const;

export type PeriodTabsEnum = typeof PeriodTabs[keyof typeof PeriodTabs];

export interface TimelineFormatterProps {
    tooltipHeader?: Highcharts.TooltipOptions['headerFormat'];
    tooltipPoint?: Highcharts.TooltipOptions['pointFormat'];
    tooltipPointError?: Highcharts.TooltipOptions['pointFormat'];
    seriesLabelFormatter?: Highcharts.DataLabelsFormatterCallbackFunction;
}

export interface RenamingPeriodPayload {
    name: string;
    id: string;
    position: {
        left: number;
        top: number;
    };
}
